<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Editar Parámetro
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <div class="row mt-4">
          <div class="col-sm-6">
            <h4 class="font-info">Datos Generales</h4>
          </div>
        </div>
        <sys-form :inputs="config_details"/>
        <!--end: Details -->
        <hr class="mt-4"/>
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'configs' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import configsService from '@/services/configs'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'ConfigUpdate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      config: {},
      config_details: {
        name: {
          name: 'Nombre',
          value: '',
          type: 'text'
        },
        value: {
          name: 'Valor',
          hint: 'Valor',
          value: '',
          type: 'text'
        },
        type: {
          name: 'Tipo',
          hint: 'Tipo',
          value: '',
          type: 'text'
        },
        description: {
          name: 'Descripción',
          hint: 'Descripción',
          value: '',
          type: 'textarea'
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    const id = this.$route.params.id
    configsService.getById(id).then(res => {
      this.config = res.data
      Object.keys(this.config_details).forEach(key => {
        if (this.config_details[key].type != 'select') {
          this.config_details[key].value = this.config[key]
        }
      })
      this.loaded = true
    })
  },
  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let configInfo = { ...this.config_details }

          let body = this.processForm(configInfo)
          let service = configsService.updateById(this.config.id, body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'configs' })
          }).catch(err => {
            console.log(JSON.stringify(err))
          })
        }
      })
    }
  },
  watch: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/configs/ConfigUpdate.vue